import { EmailOutlineIcon } from '@/assets/images';
import { useLanguage } from '@/localization/useLanguage';
import PropTypes from 'prop-types';
import './messageRequestsBanner.scss';

export const MessageRequestsBanner = ({ count = 0, onClick }) => {
   const { t } = useLanguage();

   if (!count) return null;

   return (
      <button
         type="button"
         className="message-requests-banner ct-flex ct-aiCenter ct-jcBetween"
         aria-label={t('chat.MESSAGE_REQUESTS_BANNER')}
         onClick={onClick}
      >
         <div className="message-requests-banner__left ct-flex ct-aiCenter ct-gap14">
            <span className="message-requests-banner__avatar ct-flexCenter" aria-hidden="true">
               <EmailOutlineIcon />
            </span>
            <span className="message-requests-banner__label">{t('chat.MESSAGE_REQUESTS_BANNER')}</span>
         </div>
         <output className="message-requests-banner__count ct-flexCenter">{count}</output>
      </button>
   );
};

MessageRequestsBanner.propTypes = {
   count: PropTypes.number,
   onClick: PropTypes.func,
};
